<template lang="pug">
  v-card.px-4.py-2.mb-4(flat)
    div.s2.basic600--text {{ name }} 
</template>

<script>
export default {
  name: 'OngoingEmpty',
  props: {
    groupName: {
      type: String,
      required: true
    }
  },
  computed: {
    name() {
      switch (this.groupName) {
        case 'Arranged':
          return this.$t('arranged')

        case 'Failed':
          return this.$t('failed')

        case 'Matching':
          return this.$t('matching')

        default:
          return ''
      }
    }
  }
}
</script>

<style scoped>
</style>

<i18n>
{
  "en": {
    "arranged": "Arranged",
    "failed": "Failed",
    "matching": "Matching"
  },
  "id": {
    "arranged": "Sudah diatur",
    "failed": "gagal",
    "matching": "mencari rider"
  }
}
</i18n>